module.exports = __webpack_public_path__ + "img/maryland-crab-cakes.642d1212.jpg";